import styled from "styled-components";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : LoginPage.Styles
Description : Componente que contienen todos los estilos de la pagina Login 
Date Autor Modification
================================================================================
1/10/2021 Cristian Andres Pizo Mina – Se llama al componente styled
================================================================================ */

export const DivRow = styled.div`
    display: flex;
`;
export const Div = styled.div`
    margin: auto;
    width: 100%;
    height: 100%;
`;
export const Form = styled.div`
    width: 25%;
    box-shadow: 2px 5px 15px #999;
`;

export const DivImg = styled.div`
    width: 75%;
    padding-right: 50px;
`;

export const Img = styled.img`
    width: 100%;
    padding-top: 80px;
    float: left;
`;

export const Box = styled.div`
    padding: 80px 60px;
    background: white;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 20%;

    @media (max-width: 1000px) {
        padding: 70px 30px;
    }
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	max-width: 1000px;
	margin: 0 auto;
	/* background: red; */
`

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-left: 60px;
`;

export const Row = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill,
                            minmax(185px, 1fr));
    grid-gap: 20px;

    @media (max-width: 1000px) {
        grid-template-columns: repeat(auto-fill,
                            minmax(200px, 1fr));
    }
`;

export const FooterLink = styled.a`
    color: #fff;
    margin-bottom: 20px;
    font-size: 18px;
    text-decoration: none;

    &:hover {
        color: green;
        transition: 200ms ease-in;
    }
`;

export const Heading = styled.p`
    font-size: 24px;
    color: #fff;
    margin-bottom: 40px;
    font-weight: bold;
`;
